exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image {\n  height: 50px;\n  border-radius:50%;\n}\n.style-button {\n  font-size: 0.8rem;\n  text-align: center;\n  box-sizing: border-box;\n  background: #ff8ea1;\n  border-radius: 20px;\n  padding: 5px 15px;\n  margin-left: 10px;\n  width: 60px;\n  height: 34px;\n  float: right;\n}\n.style-button p{\n  color: white;\n  font-weight: 50;\n  width: 100%;\n  line-height: 24px;\n}\n.style-input {\n  border: 1px solid;\n  border-color: #cccccc;\n  line-height: 30px;\n  margin-top: -3px;\n}\n@media screen and (max-width: 1280px) {\n.style-input {\n    line-height: 24px;\n    width: 100px;\n    height: 30px !important;\n}\n}\n", ""]);

// exports
